import {useEffect, useMemo, useState} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import EditorButton from "../../../../../../components/reports/editor-report/editor-button.jsx";
import {translate} from "../../../../../../components/translate/translate.jsx";
import EditorInput from "../../../../../../components/reports/editor-report/editor-input.jsx";

export default function OccurrenceDayWeek({ data, setMode }) {
    const [callEditor, setCallEditor] = useState(false);

    const dayWeekChart = useMemo(() => {
        const source = Array.isArray(data?.temp_analysis) ? data.temp_analysis.filter(item => item?.source === "day_week") : [];

        return {
            labels: source.map(item => translate(Number(item.day_week))),
            values: source.map(item => Number(item.qty || 0)),
        };
    }, [data]);

    useEffect(() => {
        GraphicUtils.barChart(
            "occurrence-day-week",
            dayWeekChart.values,
            dayWeekChart.labels,
        );
    }, [dayWeekChart]);

    return (
        <>
            <div className="chart-report">
                <div className="flex flex-row gap-2">
                    <span className="chart-title">Ocorrências por dia da semana</span>
                    <EditorButton callEditor={callEditor} setCallEditor={setCallEditor}/>
                </div>

                <div className="mt-3" id="occurrence-day-week"/>
            </div>

            <EditorInput callEditor={callEditor} setMode={setMode}/>
        </>
    )
}